import {ResultGiftType} from '../GiftsStore/GiftsStore.constants';
import {Winner, WinnersList, WinnersState} from './WinnersStore.types';
import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {AbstractStorage} from '@specials/localstorage';

import {LSKeys} from '@/constants';
import {ResourcesAll} from '@/resources';
import {Store} from '@/stores/Store';
import {Config} from '@/types';

export class WinnersStore extends Store<WinnersState> {
  constructor(
    private readonly localStorage: AbstractStorage,
    private readonly resources: ResourcesAll,
    private readonly config: Config,
  ) {
    super({
      winners: {
        [ResultGiftType.Stocks]: [],
        [ResultGiftType.Money]: [],
        [ResultGiftType.TShop]: [],
      },
      winner: [],
      winnerDT: null,
      activeTab: ResultGiftType.Money,
      wasSeenWinnersModal: localStorage.getItem(LSKeys.WasSeenWinnersModal) === 'true',
    });
  }

  public updateWinner = (userId?: string): void => {
    let winner = this.resources.content.winners.filter((winner) => winner.id === userId);
    const winnerDT = this.getState().winnerDT;

    if (!this.config.isProd && winnerDT) {
      winner = [winnerDT];
    }

    if (winner.length) {
      this.setValue('winners', this.buildWinnersListByWinnerUser(winner));
      this.setActiveTab(winner[0].type);
    } else {
      this.setValue('winners', this.buildWinnersList());
    }
    this.setValue('winner', winner || null);
  };

  public setWinnerDT = (winner: Winner | null): void => {
    this.setValue('winnerDT', winner);
  };

  public setActiveTab = (value: ResultGiftType): void => {
    this.setValue('activeTab', value);
  };

  public setWasSeenWinnersModal = (value: boolean): void => {
    this.setValue('wasSeenWinnersModal', value);
  };

  public getWinners = (): Winner[] => {
    return this.getState().winners[this.getState().activeTab];
  };

  public getWinner = (): Winner[] => {
    const winnerDT = this.getState().winnerDT;
    if (!this.config.isProd && winnerDT) {
      return [winnerDT];
    }
    return this.getState().winner;
  };

  public getActiveTab = (): ResultGiftType => {
    return this.getState().activeTab;
  };

  public isActiveTabMoney = (): boolean => {
    return this.getState().activeTab === ResultGiftType.Money;
  };

  public isActiveTabStocks = (): boolean => {
    return this.getState().activeTab === ResultGiftType.Stocks;
  };

  public isActiveTabTShop = (): boolean => {
    return this.getState().activeTab === ResultGiftType.TShop;
  };

  public wasSeenWinnersModal = (): boolean => {
    return this.getState().wasSeenWinnersModal;
  };

  public isWinnerTicket = (ticketNumber: string): boolean => {
    return !!this.getWinner().find((winner) => winner.ticket === ticketNumber);
  };

  private buildWinnersList = (): WinnersList => {
    return this.resources.content.winners.reduce<WinnersList>(
      (acc, winner) => {
        acc[winner.type].push(winner);
        return acc;
      },
      {
        [ResultGiftType.Stocks]: [],
        [ResultGiftType.Money]: [],
        [ResultGiftType.TShop]: [],
      },
    );
  };

  private buildWinnersListByWinnerUser = (winner: Winner[]): WinnersList => {
    const winners = this.buildWinnersList();

    winner.forEach((w) => {
      winners[w.type] = [w, ...winners[w.type].filter(({id}) => id !== w.id)];
    });

    return {
      ...winners,
    };
  };
}

injected(WinnersStore, DI_TOKENS.localStorageService, DI_TOKENS.resources, DI_TOKENS.config);
